export default "__VITE_ASSET__3af19869__"